import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import Iframe from 'react-iframe'
import './Services.css'

const Service = props => {
  const { url, ...rest } = props
  return (
    <Col className="Service" xs={12} sm={4} lgOffset={0} {...rest}>
      <Iframe frameborder="0" height="420" url={url} />
    </Col>
  )
}

const Services = () => {
  return (
    <Grid>
      <Row className="Services" componentClass="section">
        <Col xs={12} smOffset={1} sm={11} lg={12} lgOffset={0}>
          <h2>Services</h2>
        </Col>
        <Service
          url="https://www.fueleconomy.gov/feg/widgets/find-a-car/facwidget.html"
          smOffset={1}
        />
        <Service url="https://www.fueleconomy.gov/feg/widgets/gas-tips/tipwidget.html" />
        <Service url="https://afdc.energy.gov/widget/calc/" smOffset={1} />
      </Row>
    </Grid>
  )
}

export default Services



// WEBPACK FOOTER //
// ./src/components/Services.js